export const ASSIGN_HINT_DISMISSED_KEY = "split-it:assign-hint-dismissed";

const storageOf = (storage) => storage ?? window.localStorage;

const readDismissed = (storage) => {
  try {
    const value = JSON.parse(
      storageOf(storage).getItem(ASSIGN_HINT_DISMISSED_KEY),
    );
    return Array.isArray(value) ? value.map(String) : [];
  } catch (error) {
    return [];
  }
};

export const isAssignHintDismissed = (groupId, storage) =>
  groupId != null && readDismissed(storage).includes(`${groupId}`);

export const dismissAssignHint = (groupId, storage) => {
  if (groupId == null) return;
  const dismissed = readDismissed(storage);
  if (dismissed.includes(`${groupId}`)) return;
  try {
    storageOf(storage).setItem(
      ASSIGN_HINT_DISMISSED_KEY,
      JSON.stringify([...dismissed, `${groupId}`]),
    );
  } catch (error) {}
};
